import * as tslib_1 from "tslib";
import { MailRowDataPropertyGetter, getFocusedFilterForTable, getRowKeysFromRowIds, } from 'owa-mail-list-store';
export default {
    markConversationAsReadDatapoint: {
        datapoint: {
            name: function (conversationIds, tableView, isReadValue, isExplicit, actionSource) {
                var name = 'TnS_MarkConversation';
                name += isReadValue ? 'Read' : 'Unread';
                if (!isExplicit) {
                    name += 'Background';
                }
                return name;
            },
            options: function (conversationIds, tableView, isReadValue, isExplicit, actionSource) {
                return isExplicit ? { isCore: true } : {};
            },
            customData: function (conversationIds, tableView, isReadValue, isExplicit, actionSource) { return [actionSource, conversationIds.length, getFocusedFilterForTable(tableView)]; },
            cosmosOnlyData: function (conversationIds, tableView, isReadValue, isExplicit, actionSource) {
                var e_1, _a;
                var itemIds = [];
                var rowKeys = getRowKeysFromRowIds(conversationIds, tableView);
                try {
                    for (var rowKeys_1 = tslib_1.__values(rowKeys), rowKeys_1_1 = rowKeys_1.next(); !rowKeys_1_1.done; rowKeys_1_1 = rowKeys_1.next()) {
                        var rowKey = rowKeys_1_1.value;
                        itemIds.push(MailRowDataPropertyGetter.getItemIds(rowKey, tableView));
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (rowKeys_1_1 && !rowKeys_1_1.done && (_a = rowKeys_1.return)) _a.call(rowKeys_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                return JSON.stringify({ itemIds: itemIds, conversationIds: conversationIds });
            },
        },
    },
    markItemReadUnreadDatapoint: {
        datapoint: {
            name: function (tableView, itemIds, isReadValue, isExplicit, actionSource) {
                var name = 'TnS_MarkItem';
                name += isReadValue ? 'Read' : 'Unread';
                if (!isExplicit) {
                    name += 'Background';
                }
                return name;
            },
            options: function (conversationIds, tableView, isReadValue, isExplicit, actionSource) {
                return isExplicit ? { isCore: true } : {};
            },
            customData: function (tableView, itemIds, isReadValue, isExplicit, actionSource) { return [tableView.tableQuery.type, itemIds.length, getFocusedFilterForTable(tableView)]; },
            cosmosOnlyData: function (tableView, itemIds, isReadValue, isExplicit, actionSource) {
                return JSON.stringify({ itemIds: itemIds });
            },
            actionSource: function (tableView, itemIds, isReadValue, isExplicit, actionSource) { return actionSource; },
        },
    },
};
//# sourceMappingURL=datapoints.js.map